export const mainBlockData = {
	title: "page_interior_header",
	description: "page_interior_desc",
	videoUrl: "/interior_design/main_block/interior_video.mp4",
	posterUrl: "/interior_design/main_block/interior_preview.jpg",
};
export const sliderData = {
	title: "page_interior_h4",
	description: "page_interior_desc4",
	beforeUrl: "/interior_design/slider/slider_before.jpg",
	afterUrl: "/interior_design/slider/slider_after.jpg",
};

export const scrollData = [
	{
		id: 3,
		label: "Original",
		url: "/interior_design/examples_scroll/before_1.jpg",
	},
	{
		id: 4,
		label: "Result",
		url: "/interior_design/examples_scroll/after_1.jpg",
	},
	{
		id: 1,
		label: "Original",
		url: "/interior_design/examples_scroll/before_2.jpg",
	},
	{
		id: 2,
		label: "Result",
		url: "/interior_design/examples_scroll/after_2.jpg",
	},
	{
		id: 5,
		label: "Original",
		url: "/interior_design/examples_scroll/before_3.jpg",
	},
	{
		id: 6,
		label: "Result",
		url: "/interior_design/examples_scroll/after_3.jpg",
	},
	{
		id: 7,
		label: "Original",
		url: "/interior_design/examples_scroll/before_4.jpg",
	},
	{
		id: 8,
		label: "Result",
		url: "/interior_design/examples_scroll/after_4.jpg",
	},
	{
		id: 9,
		label: "Original",
		url: "/interior_design/examples_scroll/before_5.jpg",
	},
	{
		id: 10,
		label: "Result",
		url: "/interior_design/examples_scroll/after_5.jpg",
	},
];
